import { render, staticRenderFns } from "./CriarCartorio.vue?vue&type=template&id=b871c7d8&scoped=true"
import script from "./CriarCartorio.vue?vue&type=script&lang=js"
export * from "./CriarCartorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b871c7d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b871c7d8')) {
      api.createRecord('b871c7d8', component.options)
    } else {
      api.reload('b871c7d8', component.options)
    }
    module.hot.accept("./CriarCartorio.vue?vue&type=template&id=b871c7d8&scoped=true", function () {
      api.rerender('b871c7d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CriarCartorio.vue"
export default component.exports